import { Builder } from "./api.baseQuery";
import { AuthEndpoint, authEndpoint } from "./endpoint/auth/auth.endpoint";
import {
  OrganizationEndpoint,
  organizationEndpoint,
} from "./endpoint/organization/organization.endpoint";
import { UserEndpoint, userEndpoint } from "./endpoint/user/user.endpoint";

// #region INTERFACES

export type IEndpointTags<T> = Record<keyof T, string>;

// #endregion

export type IEndpoint = AuthEndpoint & OrganizationEndpoint & UserEndpoint;

const endpoint = (builder: Builder): IEndpoint => ({
  ...authEndpoint(builder),
  ...organizationEndpoint(builder),
  ...userEndpoint(builder),
});

export default endpoint;
